(function ($, root, undefined) {

$(function () {
	'use strict';

	$(document).ready(function() {

		// Check all the input fields of type email. This function will handle all the email addresses validations
		var validations ={
			email: [/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/, 'Please enter a valid email address']
		};
		$("input[type=email]").change( function(){
			// Set the regular expression to validate the email
			var validation = new RegExp(validations['email'][0]);
			// validate the email value against the regular expression
			if (!validation.test(this.value)){
				// If the validation fails then we show the custom error message
				this.setCustomValidity(validations['email'][1]);
				return false;
			} else {
				// This is really important. If the validation is successful you need to reset the custom error message
				this.setCustomValidity('');
			}
		});

		//header image
		var $header = $('.callout-img');
		var getHeaderBackground = function () {
			var background = $header.data('fullsrc');
			if (window.innerWidth < 1280 && window.innerWidth >= 1024) {
				background = $header.data('desktopsrc');
			} else if (window.innerWidth < 1024 && window.innerWidth >= 768) {
				background = $header.data('tabletsrc');
			} else if (window.innerWidth < 768 && window.innerWidth >= 480) {
				background = $header.data('landscapesrc');
			} else if (window.innerWidth < 480) {
				background = $header.data('mobilesrc');
			}
			$header.css('background-image', 'url(' + background + ')');
		};
		var resizeTimer;

		$(window).resize(function () {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(getHeaderBackground, 250);
		});

		getHeaderBackground();

		$('body').click(function(event) {
		    if(!$(event.target).closest('.slicknav_menu').length) {
		       $('.main-menu').slicknav('close');
		    }
		});

	});



	// Navigation
	$('.main-menu').slicknav({
		prependTo: '.burger-prepend',
		allowParentLinks: true,
		nestedParentLinks: true,
		showChildren: false,
		'open': function(trigger){
			$('.slicknav_menu').addClass('menuOpen');
		},
		'close': function(trigger){
			$('.slicknav_menu').removeClass('menuOpen');
		}
	});

	var secondaryNav = $('ul.mobile-nav').find('li').clone().addClass('mobile-only').prependTo('.slicknav_nav');
	var burgerDesktop = $('.main-menu.responsive-desktop').length;
	var burgerTablet = $('.main-menu.responsive-tablet').length;

	if (burgerDesktop) {
		$('.primary-nav-container').addClass('burgerDesktop');
	}
	if (burgerTablet) {
		$('.primary-nav-container').addClass('burgerTablet');
	}

	$( ".pages-nav" ).click(function(e) {
		e.preventDefault;
		$('.open-submenu').toggleClass('submenu-open');
	  $(".pages-nav > ul").slideToggle( "slow", function() {
	  });
	});

	//Columnizer support
	$(".text-col-2").columnize({ columns: 2 });
	$(".text-col-3").columnize({ columns: 3 });

	$("#lidd_mc_form").submit(function(e){
	    return false;
	});

	// phone number

	// $('.phone-number').on('click', function(e) {
	// 	e.preventDefault();
	// });

	// no next button on the most recent IDX post

	if ($('.next .title').text() == "") {
		$('.post-nav .next').hide();
	}

	// no prev button on the first IDX post

	if ($('.prev .title').text() == "") {
		$('.post-nav .prev').hide();
	}

	// adding a class to the H1s on IDX-generated pages so we can control the font sizes better
	if ($('body').hasClass('page-id-0')) {
		var h1text = $('.main-content h1');
		if (h1text.html() == "Property Search" || h1text.html() == "Featured Properties" || h1text.html() == "Search Listings" || h1text.html() == "Advanced Property Search" || h1text.html() == "Map Search" || h1text.html() == "Open Home Search" || h1text.html() == "Email Alerts" || h1text.html() == "Property Organizer" || h1text.html() == "Property Search Results" || h1text.html() == "Organizer Login")  {
			h1text.addClass('normal-h1');
		}
	}



});

})(jQuery, this);


// detect IE10 + IE11

if (/*@cc_on!@*/false) {
    document.documentElement.className+=' ie';
}

if (!(window.ActiveXObject) && "ActiveXObject" in window) {
	document.documentElement.className+=' ie';
}
